<template>
  <a class="dropdown-item cursor-pointer" @click="handle">Original</a>
</template>

<script>
import eventBus from "../../../event-bus";

export default {
  props: {
    message: Object,
    url: String,
  },

  methods: {
    /**
     * @emits
     */
    handle() {
      eventBus.$emit('on-show-original-email-message', {url: this.url, message: this.message});
    },
  },
}
</script>

<style scoped>

</style>
